export default __webpack_public_path__ + "static/ai-marketing-6-d228e46b5ba3a666584d4d5950894244.webp";